import { Show } from '@refinedev/antd'
import { useShow } from '@refinedev/core'
import { Card, Tag, Space, Typography, Tabs, Image, Descriptions } from 'antd'
import dayjs from 'dayjs'
import { STATUS_META, type BlogPostStatus } from './utils'

const { Title } = Typography

export function BlogShowPage() {
  const { query } = useShow()
  const record = query?.data?.data as Record<string, any> | undefined
  const status = (record?.status as BlogPostStatus) ?? 'DRAFT'
  const meta = STATUS_META[status] ?? STATUS_META.DRAFT

  return (
    <Show isLoading={query?.isLoading}>
      <Space direction="vertical" size={16} style={{ width: '100%' }}>
        <Space align="center">
          <Title level={3} style={{ margin: 0 }}>
            {record?.titleSr}
          </Title>
          <Tag color={meta.color}>{meta.label}</Tag>
        </Space>

        {record?.coverImageUrl && (
          <Image src={record.coverImageUrl} alt="cover" style={{ maxHeight: 240, borderRadius: 8 }} />
        )}

        <Descriptions column={2} bordered size="small">
          <Descriptions.Item label="Slug (SR)">/{record?.slugSr}</Descriptions.Item>
          <Descriptions.Item label="Kategorija">{record?.category || '—'}</Descriptions.Item>
          <Descriptions.Item label="Objavljeno">
            {record?.publishedAt ? dayjs(record.publishedAt).format('DD.MM.YYYY HH:mm') : '—'}
          </Descriptions.Item>
          <Descriptions.Item label="Izmenjeno">
            {record?.updatedAt ? dayjs(record.updatedAt).format('DD.MM.YYYY HH:mm') : '—'}
          </Descriptions.Item>
        </Descriptions>

        <Card>
          <Tabs
            items={[
              {
                key: 'sr',
                label: '🇷🇸 Srpski',
                children: (
                  <div dangerouslySetInnerHTML={{ __html: record?.contentHtmlSr || '<em>Nema sadržaja</em>' }} />
                ),
              },
              {
                key: 'en',
                label: '🇬🇧 English',
                children: (
                  <div dangerouslySetInnerHTML={{ __html: record?.contentHtmlEn || '<em>No content</em>' }} />
                ),
              },
            ]}
          />
        </Card>
      </Space>
    </Show>
  )
}

export default BlogShowPage
